<template>
  <DialogCard>
    <template #title>
      About
    </template>
    <template #text>
      <p>
        Our mission: To help people store and make sense of their medical images.
      </p>
      <p>
        Our objectives: We want to give people full control over health data they already own,
        especially their medical images. By doing so, we want to do our part in improving
        healthcare, advancing more accurate diagnoses, and possibly preventing disease. We also
        strive to radically boost research around medical images, giving medical professionals,
        imaging centers, and scientist precise tools to derive new and better insights from medical
        images.
      </p>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeAboutDialog',
  components: {
    DialogCard,
  },
};
</script>
